import {PolyDictionary} from '../../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref} from 'vue';
import {BaseCodeDisplayer} from './_Base';
import {ParticlesSystemGpuSopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/ParticlesSystemGpu';
import {ShaderName} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/utils/shaders/ShaderName';

export class MultiShaderCodeDisplayer {
	static async update(
		node: ParticlesSystemGpuSopNode,
		shadersByName: Ref<PolyDictionary<string>>,
		shaderNames: Ref<string[]>
	) {
		await node.compute();
		BaseCodeDisplayer.clear(shadersByName, shaderNames);
		const nodeShadersByName = node.shadersByName();
		const nodeShaderNames: ShaderName[] = [];
		nodeShadersByName.forEach((shader, shaderName) => {
			nodeShaderNames.push(shaderName);
		});
		for (let shaderName of nodeShaderNames) {
			const shader = nodeShadersByName.get(shaderName);
			if (shader) {
				shadersByName.value[shaderName] = shader;
				shaderNames.value.push(shaderName);
			}
		}
	}
}
